import { define, ui } from '@owenscorning/pcb.alpha';

import Renderer from '../../../../OC/PageBuilder/LumberDeckingCalculator';

export default define`Lumber Decking Calculator`('0.0.1')({
  thumbnail: ui`Modules/Page/Thumbnails/LumberDeckingCalculator`,
  category: ui`Modules/Categories/Page/Prebuilt`,
  // eslint-disable-next-line
  view: ({ value }) => <Renderer {...value} />,
  edit: {
    copy: ui`Content/Basic`({
      label: 'Header',
      default: {
        prehead: '',
        heading: 'Enter Project Dimensions',
        bodyCopy: 'Rectangular shape assumed. If deck is not Rectangular, break up into Rectangular sections',
      },
    }),
  },
});
